import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'orange' | 'white';
type ButtonSize = 'sm' | 'md' | 'lg' | 'xl';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
  href?: string;
  fullWidth?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  children,
  href,
  fullWidth = false,
  className = '',
  ...props
}) => {
  const baseClasses = 'font-semibold rounded-lg transition-all transform hover:scale-105 text-center';

  const variantClasses = {
    primary: 'bg-sky-500 text-white hover:bg-sky-600 shadow-lg',
    secondary: 'bg-gray-500 text-white hover:bg-gray-600',
    outline: 'border-2 border-white text-white hover:bg-white hover:text-sky-600',
    orange: 'bg-orange-500 text-white hover:bg-orange-600 shadow-lg',
    white: 'bg-white text-sky-600 hover:bg-gray-100',
  };

  const sizeClasses = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-3 text-lg',
    xl: 'px-8 py-4 text-xl',
  };

  const widthClass = fullWidth ? 'w-full' : 'inline-block';

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${className}`;

  if (href) {
    return (
      <a href={href} className={classes}>
        {children}
      </a>
    );
  }

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};

export default Button;